import { createSlice } from '@reduxjs/toolkit'
import { FirestoreDatabase } from '../index'
import { Collection } from 'constants/index'
import { signOut } from 'store/auth'
import { toast } from 'utils/notify'

export const initialState = {
  error: null,
  inProgress: false,
  sponsors: [],
  sponsor: null,
  currentPage: 0,
  pageSize: 10
}

const sponsorSlice = createSlice({
  name: 'sponsor',
  initialState: initialState,
  reducers: {
    setError: (state, action) => {
      state.error = action.payload
    },
    setProgress: (state, action) => {
      state.inProgress = action.payload
    },
    setSponsors: (state, action) => {
      state.sponsors = action.payload
    },
    setSponsor: (state, action) => {
      state.sponsor = action.payload
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload
    }
  },
  extraReducers: {
    [signOut.fulfilled]: (state) => {
      state.error = null
      state.inProgress = false
      state.sponsors = []
      state.sponsor = null
      state.currentPage = 0
      state.pageSize = 10
    }
  }
})

export const getConferenceSponsors = async (conferenceId) => {
  try {
    const levelsSnapshot = await FirestoreDatabase.collection(Collection.SPONSORSHIP_LEVELS)
      .where('conferenceId', '==', conferenceId)
      .where('sponsorshipTier', '==', 1)
      .get()

    const exhibitorLevelId = levelsSnapshot?.docs?.[0]?.id || ''

    const snapshot = await FirestoreDatabase.collection(Collection.ORGANIZATIONS)
      .where('conferenceId', '==', conferenceId)
      .get()

    return snapshot?.docs
      ?.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }))
      .filter((org) => org.sponsorshipLevelId !== exhibitorLevelId)
  } catch (error) {
    console.error(error)
    toast.error('Could not load sponsors.')
    return []
  }
}

export default sponsorSlice
